import ABSService from "./absService";

class SuperGroupService extends ABSService {
    constructor() {
        super("super-group");
    }
}

export default SuperGroupService;